import { useState } from 'react';
import { Button } from '@ordr-as/umami-react/button';
import { TextInput } from '@ordr-as/umami-react/form';
import useIntl from '../../../../../hooks/useIntl';
import { FormattedMessage } from 'react-intl';
import BackButton from '../../../../../components/BackButton';
import { useCheckout } from '../../../../../context/CheckoutContext';
import { useScreenSize } from '../../../../../context/ScreenSizeContext';
import { useNavigate } from 'react-router-dom';
import { createMenuUrl } from '../../../../../utils/linkBuilder';
import { useLocation } from '../../../../../context/LocationContext';
import { useCartStore } from '../../../../../context/cart/CartStore';
import { useDigitalBillActions } from '../../../../../context/DigitalBillStore';

const SetTableNumberDialog = () => {
  const intl = useIntl();
  const [tableNumber, setTableNumber] = useState<string>('');
  const { setTableNumber: setTableNumberInState, setSidebarContent } = useCheckout();
  const { setActiveDigitalBill } = useDigitalBillActions();
  const tableNumberWithoutLeading0s = tableNumber.replaceAll(/^0+/g, '');
  const { isPhone } = useScreenSize();
  const cartIsEmpty = useCartStore((state) => state.cart.orderLines.length < 1);

  const navigate = useNavigate();
  const { location, isDigitalBillEnabled } = useLocation();

  const isValidInput = () => {
    const inputIsOnly0s = /^0*$/.test(tableNumber);
    return !tableNumber || inputIsOnly0s;
  };

  const onSubmit = () => {
    setActiveDigitalBill(undefined);
    setTableNumberInState(tableNumberWithoutLeading0s);
    setSidebarContent('CART');

    if (isPhone && cartIsEmpty) {
      navigate(createMenuUrl(location.locationId));
    }
  };

  const onClose = () => {
    if (!isDigitalBillEnabled) {
      setSidebarContent('CART');
      return;
    }

    setSidebarContent('SELECT_TABLE');
  };

  const shouldShowNoLeading0sHelpText = !tableNumberWithoutLeading0s && tableNumber.length > 0;

  return (
    <>
      <BackButton title="New Table" navigateTo={onClose} />
      <article className="flex flex-col h-full justify-between">
        <section className="flex p-4 flex-col gap-5">
          <TextInput
            autoFocus
            value={tableNumber}
            onChange={setTableNumber}
            data-cy="table-number"
            label={intl.formatMessage({ id: `checkout.deliveryPoint.primary.TABLE` })}
            type="number"
            required
            fullWidth
          />
          {shouldShowNoLeading0sHelpText && (
            <p className="text-orange-darkest text-xs">
              <FormattedMessage id="digitalBill.create.leadingZerosDisallowed" />
            </p>
          )}
        </section>
        <Button
          kind="primary"
          data-cy="set-table-number"
          className="mx-2 mb-4"
          isDisabled={!isValidInput}
          onClick={onSubmit}
        >
          Set table
        </Button>
      </article>
    </>
  );
};

export default SetTableNumberDialog;
